import React, { useEffect, useMemo, useRef, useState } from "react";
import Datatable from "components/Core/DataTable";
import {
	Row,
	Col,
	ModalHeader,
	ModalBody,
	Form,
	Button,
	ModalFooter,
	Modal,
	Container,
} from "reactstrap";
import Notify from "../../lib/Utils/Alert";
import { MotionButton } from "../../components/Core/MotionStrap";
import NotificationAlert from "react-notification-alert";
import PurchaseOrder from "../../lib/Core/Backend/Controllers/PurchaseOrder";
import ShoppingCartPurchaseOrder from "../../lib/Core/Backend/Controllers/ShoppingCartPurchaseOrder";
import PurchaseForm from "components/PurchaserFrontend/PurchaseOrder/PurchaseForm";
import GiftCardsFileForm from "components/PurchaseOrder/GiftCardsFileForm";
import FileUpload from "lib/Core/Backend/Controllers/FileUpload";
import Brand from "lib/Core/Backend/Controllers/Brand";
import CardType from "lib/Core/Backend/Controllers/CardType";
import { SwipeableDrawer } from "@mui/material";
import OrderDetails from "components/PurchaseOrder/OrderDetails";
import useCatalogs from "hooks/useCatalogs";
import ModalConfirm from "components/Purchaser/ModalConfirm";
import ModalDownloadFilePdfCsv from "components/Modal/DownloadFilePdfCsv";
import html2pdf from 'html2pdf.js';
import Utils from 'lib/Utils/Utils';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import dataTable from "../../assets/scss/react/dataTable.scss"

const dollarUSLocale = Intl.NumberFormat('en-US', {
	style: "currency",
	currency: "USD",
});
function PurchaserPurchaseOrderView({ purchaserId, token }) {
	const { currencies } = useCatalogs();
	const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token), [token]);
	const shoppingCartPurchaseOrderCtl = useMemo(
		() => new ShoppingCartPurchaseOrder(token),
		[token]
	);
	const fileUploadCtl = useMemo(() => new FileUpload(token), [token]);
	const brandsCtl = useMemo(() => new Brand(token), [token]);
	const cardTypeCtl = useMemo(() => new CardType(token), [token]);

	const [fileUrl, setFileUrl] = useState(null);
	const [giftCardsFile, setGiftCardsFile] = useState();
	const [giftCardsFileInfo, setGiftCardsFileInfo] = useState({});
	const [purchaseOrder, setPurchaseOrder] = useState({});
	const [purchaseDetails, setPurchaseDetails] = useState([]);
	const [purchaseOrderName, setPurchaseOrederName] = useState("");
	const [modal, setModal] = useState(false);
	const [modalGiftCardsFileForm, setModalGiftCardsFileForm] = useState(false);
	const [confirmModal, setConfirmModal] = useState(false);
	const [openDrawer, setOpenDrawer] = useState(false);
	const [reload, setReload] = useState(true);
	const [modalConfirm, setModalConfirm] = useState(false)
	const [filteredBrands, setFilteredBrands] = useState([]);
	const [orderreferenceValue,setOrderReferenceValue] = useState("");

	const handleReferenceValueChange = (newValue) =>{
		setOrderReferenceValue(newValue);
	}
	const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false)

	const openModel = () => {
		setIsDownloadModalOpen(!isDownloadModalOpen)
		setFilteredBrands([]);
	}
	const modalConfirmToggle = () => setModalConfirm(!modalConfirm)
	const toggle = () => setModal(!modal);
	const toggleGiftCardsFileForm = () =>
		setModalGiftCardsFileForm(!modalGiftCardsFileForm);
	const toggleConfirm = () => setConfirmModal(!confirmModal);
	const toggleDrawer = () => setOpenDrawer(!openDrawer);
	const triggerReload = () => setReload(!reload);

	const [activeOp, setActiveOp] = useState("Add New");
	const [operativeRow, setOperativeRow] = useState({});
	const [orderDetail, setOrderDetail] = useState();
	const [brands, setBrands] = useState([]);
	const [cardTypes, setCardTypes] = useState([]);

	const [startDate, setstartDate] = useState('');
	const [endDate, setendDate] = useState('');

	const table = useRef();
	const alert = useRef();
	const downloadLink = useRef();
	const startDateInput = useRef();
	const endDateInput = useRef();
	const toggleCreatePurchaseOrder = () => {
		setModal(false)
	}


	const header = [
		{
			title: "Date",
			data: "createdAt",
			sortable: true,
			searchable: true,
			renderForSelect: (data) => ({ label: data, value: data }),
			type: 'date'
		},
		{ title: "Name", data: "name", sortable: true, searchable: true },
		{ title: "Order Reference", data: "orderReference", sortable: true, searchable: true },
		{ title: "Currency", data: "currency", sortable: true, searchable: true },
		{
			title: "Total Gift Card",
			data: "subtotal",
			sortable: true,
			searchable: true,
			type: 'currency',
			width: '10%'
		},
		{
			title: "Total Amount",
			data: "totalAmount",
			sortable: true,
			searchable: true,
			type: 'currency',
			width: '10%'
		},
		{
			title: "Total Quantity",
			data: "totalQuantity",
			sortable: true,
			searchable: true,
			type: 'number',
			width: '10%'
		},
		{
			title: "Status",
			data: "status",
			sortable: true,
			searchable: true,
			render: (data) => {
				if (data) {
					switch (data) {
						case 1:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-info">open</span>`;

						case 2:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-nileBlue">in progress</span>`;

						case 3:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">canceled</span>`;

						case 4:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-shamrock">completed</span>`;

						case 5:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalYellow">Processing</span>`;
						case 6:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalAssColor">Awaiting payment</span>`;
						case 7:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalAssColor">Awaiting payment</span>`;
						case 8:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalOrange">Incomplete</span>`;
						case 9:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalAssColor">Awaiting payment</span>`;
						case 10:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalAssColor">Awaiting payment</span>`;
						case 11:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalOrange">Incomplete</span>`;
						case 12:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalOrange">Incomplete</span>`;
						default:
							return "Error";
					}
				}
			},
			renderForSelect: (data) => {
				if (data) {
					switch (data) {
						case 1:
							return {
								label: `open`,
								value: 'open',
							};

						case 2:
							return {
								label: `in progress`,
								value: 'in progress',
							};

						case 3:
							return {
								label: `canceled`,
								value: 'canceled',
							};

						case 4:
							return {
								label: `completed`,
								value: 'completed',
							};

						case 5:
							return {
								label: `on hold`,
								value: 'on hold',
							};
						case 6:
							return {
								label: `API low fund`,
								value: 'API low fund',
							};
						case 7:
							return {
								label: `Non API low fund`,
								value: 'Non API low fund',
							};
						case 8:
							return {
								label: `Incomplete`,
								value: 'Incomplete',
							};
						case 9:
							return {
								label: `Invoice Order`,
								value: 'Invoice Order',
							};
						case 10:
							return {
								label: `Non API Invoice Order`,
								value: 'Non API Invoice Order',
							};

						default:
							return {
								label: "error",
								value: 'error',
							};
					}
				}
			},
		},
	];

	function prepareToAdd() {
		toggle();
		setActiveOp("Add New");
		setPurchaseOrederName(`PCSR-PO-${+new Date()}`);
	}

	const createPurchaseOrder = () => {
		shoppingCartPurchaseOrderCtl.addPurcharseOrder(
			purchaseOrder,orderreferenceValue,
			(data) => {
				if (data.error) {
					Notify(alert, "danger", data.error);
				} else {
					triggerReload();
				}
			}
		)
	}

	const onModalConfirmBack = () => {
		modalConfirmToggle();
		toggleCreatePurchaseOrder()
	}

	const onModalConfirmDone = () => {
		modalConfirmToggle();
		createPurchaseOrder();
	}

	const modalOrderToConfirm = () => {
		if (purchaseDetails.length) {
			modalConfirmToggle();
			toggleCreatePurchaseOrder()
		} else {
			Notify(alert, 'danger', "Please make a order");
		}
	}

	function confirmDelete() {
		const row = operativeRow;
		setOperativeRow(null);
		row.remove().draw();
		toggleConfirm();
	}

	function handleModalAlerts(data) {
		Notify(alert, "danger", data);
	}

	function uploadGiftCardsFile(e) {
		e.preventDefault();
		if (!!giftCardsFile) {
			fileUploadCtl.add(giftCardsFile, giftCardsFileInfo);
			toggleGiftCardsFileForm();
		}
	}

	const prepareDetails = (row) => {
		setOrderDetail(row.data());
		toggleDrawer();
	};

	const downloadFulfillment = (e) => {
		purchaseOrderCtl.fulfillmentFile(orderDetail.name, data => {
			if (data.error) {
				Notify(alert, 'danger', 'Something went wrong')
			} else {
				setFileUrl(data.downloadLink)
			}
		})
	}

	useEffect(() => {
		if (fileUrl)
			downloadLink.current.click()
		setFileUrl(null)
	}, [fileUrl]);

	useEffect(() => {
		brandsCtl.all((data) => {
			if (data.error || data.errorMessage) {
				Notify(alert, "danger", data.errorMessage ?? data.error);
			} else {
				setBrands(data);
			}
		});

		cardTypeCtl.all((data) => {
			if (data.error || data.errorMessage) {
				Notify(alert, "danger", data.errorMessage ?? data.error);
			} else {
				setCardTypes(data);
			}
		});
	}, [brandsCtl, cardTypeCtl]);

	useEffect(() => {
		if (!!purchaserId) {
			purchaseOrderCtl.allBySource(purchaserId, (data) => {
				if (data && !data.error) {
					let purchaseOrders = data.map((order) => {
						let orderCurrency = currencies.find(currency => currency.id === order.currencyId)
						const currencyFormat = new Intl.NumberFormat('en-US', {
							style: 'currency',
							currency: orderCurrency?.code ?? 'USD'
						})
						order.totalAmount = currencyFormat.format(order.totalAmount);
						order.subtotal = currencyFormat.format(order.subtotal)
						return { ...order, currency: orderCurrency?.code ?? 'USD' };
					});
					if (table.current)
						table.current.dataTable.clear().rows.add(purchaseOrders).draw();
				} else {
					Notify(alert, "danger", data.errorMessage ?? data.error);
				}
			});
		}
	}, [reload, purchaserId]);

	///// onchange function for select date ////

	const handleDate = (e) => {
		if (e.target.id === 'startDate') {
			setstartDate(e.target.value)
			setendDate(null)
			endDateInput.current.value = '';
			endDateInput.current.select();
		} else {
			if (!startDate) {
				Notify(alert, 'danger', 'First Select a start date');
				endDateInput.current.value = '';
				startDateInput.current.focus();
				return;
			}
			setendDate(e.target.value)
		}
	}


	////// API call to get purchaser order after select start date and end date ////////
	useEffect(() => {
		if (startDate && endDate) {
			purchaseOrderCtl.downloadPurchaserOrder(purchaserId, startDate, endDate, (data) => {
				if (data && !data.error) {
					setFilteredBrands(data)
				} else {
					Notify(alert, "danger", data.errorMessage ?? data.error);
				}
			});
		}
	}, [startDate && endDate])

	//// create table to download pdf file of puchaser order ///////

	const downloadPdf = () => {
		// Create a new jsPDF instance
		if (filteredBrands?.length == []) {
			Notify(alert, 'danger', 'First Select a start date and End date');
		}
		else {
			const doc = new jsPDF();

			// Define table headers
			const headers = [['Brand','Date', 'Name', 'Order', 'Face Val', 'Qty', 'Disc', 'Disc Val', 'Total', 'Status']];

			// Define data for the table
			const rows = filteredBrands?.map(obj => [obj.brand, obj.date , obj.customerName, obj.orderName, " $ "+parseFloat(obj.faceValue).toFixed(2), parseFloat(obj.quantity).toFixed(2), parseFloat(obj.discount).toFixed(2)+" % ", " $ "+obj.discountValue, " $ "+obj.totalValue, obj.status]);

			// Set the table structure
			doc.autoTable({
				head: headers,
				body: rows,
				styles: { fontSize: 8 },
			});
			doc.save('orders.pdf');

		}

	};

	//// create table to download csv file of purchaser order ///////

	const arrayToCSV = (arr) => {
		const columnNames = Object.keys(arr[0]);
		const columnHeaders = columnNames.join(',');
		const rows = arr.map((item) => Object.values(item).join(',')).join('\n');
		return `${columnHeaders}\n${rows}`;
	};

	const downloadCsvFile = () => {
		if (filteredBrands?.length == []) {
			Notify(alert, 'danger', 'First Select a start date and End date');
		}

		else {
			const csvData = arrayToCSV(filteredBrands);
			const blob = new Blob([csvData], { type: 'text/csv' });

			// Create a link element
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = 'orders.csv';

			// Append the link to the body
			document.body.appendChild(link);

			// Trigger the download
			link.click();

			// Clean up by removing the link
			document.body.removeChild(link);
		}
	};

	return (
		<>
			<Row className="justify-content-between mt-5 mx-4">
				<Col md="6">
					<h1>Purchase Orders</h1>
				</Col>

				<Col md="6" className={"align-content text-right"}>
					<MotionButton
						initial={{ x: "-500%", opacity: 0 }}
						animate={{
							x: 0,
							opacity: 1,
							transition: { delay: 0.4, duration: 0.5 },
						}}
						color="primary"
						onClick={prepareToAdd}
					>
						<i className="fas fa-shopping-cart" /> Create new Purchase Order
					</MotionButton>
					<MotionButton
						initial={{ x: "-500%", opacity: 0 }}
						animate={{
							x: 0,
							opacity: 1,
							transition: { delay: 0.4, duration: 0.5 },
						}}
						color="primary"
						onClick={openModel}
					>
						Download Historical Order
					</MotionButton>
				</Col>
			</Row>
			<NotificationAlert ref={alert} />
			<ModalDownloadFilePdfCsv endDateInput={endDateInput} startDateInput={startDateInput} handleDate={handleDate} startDate={startDate}
				isOpen={isDownloadModalOpen} toggle={openModel} downloadPdf={downloadPdf} downloadCsvFile={downloadCsvFile} purchaserOrder={"purchaserOrder"} />
			<Container className="mt-5" fluid>
				<Row>
					<Col md="12">
					<div className="table-responsive">
						<Datatable
							ref={table}
							columns={header}
							data={null}
							options={{
								saveState: false,
								order: [[0, "desc"]],
								dom: 'tip',
								language: {
									paginate: {
										next: "<i class='fas fa-angle-right'></i>",
										previous: "<i class='fas fa-angle-left'></i>",
									},
								},
							}}
							className="new_style"
							addCustomButtons={[
								{
									callback: prepareDetails,
									name: "purchaserDetails",
									icon: "fas fa-info-circle",
									style:
										"padding: 5px 10px; background: transparent; font-size: 1.2rem",
									props:
										'data-toggle="tooltip" data-placement="top" title="See Order details"',
								},
							]}
							enableSelectFilters={true}
						/>
						</div>
					</Col>
				</Row>
				<ModalConfirm isOpen={modalConfirm} toggle={modalConfirmToggle} onBack={onModalConfirmBack} onConfirm={onModalConfirmDone} data={purchaseDetails} />
				<Modal
					token={token}
					isOpen={modal}
					toggle={toggle}
					backdrop="static"
					centered={true}
					size="xl"
				>
					<ModalHeader toggle={toggle} className="bg-info">
						{activeOp} Order
					</ModalHeader>
					<Form>
						<ModalBody>
							<PurchaseForm
								name={purchaseOrderName}
								setPurchaseOrder={setPurchaseOrder}
								setPurchaseOrderDetails={setPurchaseDetails}
								loggedInPurchaser={purchaserId}
								token={token}
								currencies={currencies}
								onReferenceValueChange={handleReferenceValueChange}
							/>
						</ModalBody>
						<ModalFooter>
							<Button type="button" color="secondary" onClick={toggle}>
								Cancel
							</Button>{" "}
							<Button type="button" color="primary" onClick={modalOrderToConfirm}>
								Next
							</Button>
						</ModalFooter>
					</Form>
				</Modal>
				<Modal
					isOpen={modalGiftCardsFileForm}
					toggle={toggleGiftCardsFileForm}
					backdrop="static"
					centered={true}
					size="sm"
				>
					<ModalHeader
						toggle={toggleGiftCardsFileForm}
						className="bg-info"
					>{`Upload gift cards file for ${purchaseOrder.name}`}</ModalHeader>
					<Form>
						<ModalBody>
							<GiftCardsFileForm
								openAlert={handleModalAlerts}
								setFile={setGiftCardsFile}
								purchaseOrder={purchaseOrder}
								setFileInfo={setGiftCardsFileInfo}
							/>
						</ModalBody>
						<ModalFooter>
							<Button
								type="button"
								color="secondary"
								onClick={toggleGiftCardsFileForm}
							>
								Cancel
							</Button>{" "}
							<Button
								type="submit"
								color="primary"
								onClick={uploadGiftCardsFile}
							>
								Save
							</Button>
						</ModalFooter>
					</Form>
				</Modal>
				<Modal isOpen={confirmModal} toggle={toggleConfirm} backdrop="static">
					<ModalHeader className="bg-warning" toggle={toggleConfirm}>
						Remove Category
					</ModalHeader>
					<ModalBody>
						<p className="card-just-text">
							Are you sure you want to remove the order "
							{!!operativeRow && !!operativeRow.data
								? operativeRow.data().name
								: ""}
							"?
						</p>
					</ModalBody>
					<ModalFooter>
						<Button type="button" color="secondary" onClick={toggleConfirm}>
							Cancel
						</Button>{" "}
						<Button type="button" color="primary" onClick={confirmDelete}>
							Yes
						</Button>
					</ModalFooter>
				</Modal>
			</Container>
			<SwipeableDrawer
				anchor="right"
				open={openDrawer}
				onClose={toggleDrawer}
				onOpen={toggleDrawer}
			>
				<div style={{ width: "60vw" }}>
					<OrderDetails
						order={orderDetail}
						token={token}
						brands={brands.result}
						cardTypes={cardTypes}
					/>
				</div>
				{orderDetail?.status === 4 ?
					<Row className="mx-5">
						<Col sm={3}>
							<Button type="button" color="primary" onClick={downloadFulfillment}>Download</Button>
						</Col>
					</Row>
					: null
				}

			</SwipeableDrawer>
			{fileUrl &&
				<a ref={downloadLink} href={fileUrl} download={orderDetail.name} > </a>
			}
		</>
	);
}

export default PurchaserPurchaseOrderView;
